export default "__VITE_ASSET__BydJHObn__"